import { render, staticRenderFns } from "./show-list-big-img.vue?vue&type=template&id=1f032ec8&scoped=true"
import script from "./show-list-big-img.vue?vue&type=script&lang=js"
export * from "./show-list-big-img.vue?vue&type=script&lang=js"
import style0 from "./show-list-big-img.vue?vue&type=style&index=0&id=1f032ec8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f032ec8",
  null
  
)

export default component.exports